<template>
  <v-card class="pa-4 mt-6" outlined>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="36"/>
    </v-overlay>
    <div class="d-flex justify-space-between align-center mb-4">
      <h3 class="text-h6 font-weight-bold">{{ title }}</h3>
      <div class="d-flex align-center">
        <v-select
          v-for="metricGroup in metricGroups"
          :key="metricGroup.key"
          v-if="metricGroup.show"
          :value="metricGroup.selected"
          @change="$emit('update:metric-group-selection', { groupKey: metricGroup.key, value: $event })"
          :items="metricGroup.items"
          :label="metricGroup.label"
          item-text="text"
          item-value="value"
          dense
          hide-details
          class="mr-4"
          style="max-width: 150px;"
        ></v-select>
        <v-btn-toggle
          v-if="hasMultipleChartTypes"
          v-model="localActiveKey"
          dense
          borderless
          mandatory
        >
          <v-btn v-for="(type, key) in availableCharts" :key="key" :value="key">{{ type.name }}</v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <v-row>
      <v-col cols="12" lg="8">
        <!-- Mixed Chart (vue-chartjs) -->
        <div v-if="activeChartConfig.chartType === 'mixed'" style="height: 400px">
          <EchartsMixed
            :option="activeChartConfig.chartOptions"
            theme="westeros"
          />
        </div>
        <!-- Line Chart (ECharts direct) -->
        <div v-else-if="activeChartConfig.chartType === 'line'" ref="echart" style="height: 400px; width: 100%"></div>
      </v-col>
      <v-col cols="12" lg="4">
        <data-table-v2 :headers="activeChartConfig.tableData.headers" :items="activeChartConfig.tableData.items"/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import * as echarts from 'echarts';
import DataTableV2 from './DataTableV2.vue';
import EchartsMixed from "@/components/analytics/EchartsMixed.vue";

export default {
  name: 'ChartSectionV2',
  components: {
    EchartsMixed,
    DataTableV2
  },
  props: {
    title: String,
    activeKey: String,
    loading: Boolean,
    availableCharts: Object, // e.g. { mixed: { name: '混合圖', ... }, line: { name: '折線圖', ... } }
    metricGroups: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      echartInstance: null,
      // activeType: null
    }
  },
  computed: {
    hasMultipleChartTypes() {
      return Object.keys(this.availableCharts || {}).length > 1;
    },
    activeChartConfig() {
      if (this.availableCharts && this.availableCharts[this.activeKey]) {
        return this.availableCharts[this.activeKey]
      } else {
        return {chartData: {}, chartOptions: {}, tableData: {}}
      }
    },
    localActiveKey: {
      get: function () {
        return this.activeKey
      },
      set: function (newVal) {
        this.$emit('update:active-key', newVal);
        if (newVal === 'line') {
          this.$nextTick(this.initEchart);
        } else {
          this.disposeEchart();
        }
      }
    }
  },
  watch: {
    // activeType(newVal, oldVal) {
    //   this.$emit('update:active-type', newVal);
    //   if (newVal === 'line') {
    //     this.$nextTick(this.initEchart);
    //   } else {
    //     this.disposeEchart();
    //   }
    // },
    // Watch the options of the active chart
    'activeChartConfig.chartOptions': {
      handler(newOption) {
        if (this.activeChartConfig.chartType === 'line' && this.echartInstance && newOption) {
          this.echartInstance.setOption(newOption, true);
        }
      },
      deep: true
    },
    metricGroups: {
      handler(newV) {
        if (this.activeChartConfig.chartType === 'line') this.$nextTick(this.initEchart);
      },
      deep: true
    }
  },
  methods: {
    initEchart() {
      this.disposeEchart();
      const chartDom = this.$refs.echart;
      if (chartDom) {
        this.echartInstance = echarts.init(chartDom, 'westeros');
        this.echartInstance.setOption(this.activeChartConfig.chartOptions);
      }
    },
    disposeEchart() {
      if (this.echartInstance) {
        this.echartInstance.dispose();
        this.echartInstance = null;
      }
    }
  },
  mounted() {
    if (this.activeChartConfig.chartType === 'line') {
      this.initEchart();
    }
  },
  beforeDestroy() {
    this.disposeEchart();
  }
};
</script>
